import { ScopeSet } from 'root/src/shared/@types/auth';
import { getCookie } from 'root/src/client/v2/browser/helpers/cookies';
import { getDesiredScopeCookieKey, isScopeSet } from 'root/src/shared/users/helpers/scopeSet.helpers';
import { useIsCreator } from 'root/src/client/v2/auth/hooks/useIsCreator';
import { useIsViewer } from 'root/src/client/v2/auth/hooks/useIsViewer';
/**
 * @description
 * How we select a ScopeSet?
 * 1. Check a `scopeSet` param.
 *
 * 2. Check the desired scope stored in the cookies
 * The desired scope cookie comes from the `daredrop-auth`.
 * For more details check:
 * `daredrop-auth/src/lambdas/authApi/routes/actions/public/oauth/services/oauth2.service.ts:549`
 *
 * 3. Based on calculations.
 */
export const useScopeSet = (params) => {
    const { isCreator } = useIsCreator();
    const { isViewer } = useIsViewer();
    if (params.scopeSet) {
        return params.scopeSet;
    }
    const cookieKey = getDesiredScopeCookieKey(params.provider);
    const desiredScope = Number(getCookie(cookieKey));
    if (isScopeSet(desiredScope)) {
        return desiredScope;
    }
    const isViewerScopeSet = isViewer && !isCreator;
    return isViewerScopeSet ? ScopeSet.viewer : ScopeSet.default;
};
